<template>
  <div v-loading="loading">
    <Form>
      <Row class="m-b">
        <Col span="8">
          <FormItem :label="l('SHENGQINGREN')">{{item.applyUserName}}</FormItem>
        </Col>
        <Col span="8">
          <FormItem :label="l('SUOSHUZUZHI')">{{item.domainName}}</FormItem>
        </Col>
        <Col span="8">
          <FormItem :label="l('GUANLIWEIDU')">{{item.dimensionNames}}</FormItem>
        </Col>
      </Row>
      <table class="plan-table">
        <tr>
          <th>{{l("JIANGSHIGONGHAO")}}</th>
          <th>{{l("JIANGSHIMINGCHENG")}}</th>
          <th>{{l("SUOSHUZUZHI")}}</th>
          <th>{{l("ZHIWEI")}}</th>
          <th>{{l("SHENQINGLEIBIE")}}</th>
          <th>{{l("SHENGQINGJIBIE")}}</th>
          <th>{{l("NIJIANGSHOUKECHENGMINGCHENG")}}</th>
          <th>{{l("KECHENGZHUTIGANGYAO")}}</th>
          <th>{{l("KECHENGSHOUZHONG")}}</th>
          <th>{{l("PEIXUNXINGSHI")}}</th>
          <th>{{l("PEIXUNKESHI")}}</th>
        </tr>
        <tr v-for="(i,index) in item.trainTeacherTempList" :key="index">
          <td>{{i.staffId}}</td>
          <td>{{i.userName}}</td>
          <td>{{i.userDomainFullName}}</td>
          <td>{{i.jobName}}</td>
          <td>{{i.parentLevelName}}</td>
          <td>{{i.levelName}}</td>
          <td>{{i.draftCourseName}}</td>
          <td>{{i.thematicOutline}}</td>
          <td>{{i.courseAccess}}</td>
          <td>{{i.trainForm}}</td>
          <td>{{i.trainHour}}</td>
          <td>
            <span v-for="(month,index) in i.months" :key="index">{{month}}{{l("YUE")}},</span>
          </td>
          <td>{{i.teacherNames}}</td>
        </tr>
      </table>
    </Form>
  </div>
</template>

<script>
export default {
  name: "teacherAudit",
  props: ["id"],
  data() {
    return {
      loading: false,
      item: {}
    };
  },
  methods: {
    _fetch(id) {
      if (id) {
        this.loading = true;
        this.http
          .request("sys/trainTeacherApply/info", { id: id })
          .then(result => {
            this.item = result.item;
          })
          .finally(() => (this.loading = false));
      }
    }
  },
  created: function() {
    this._fetch(this.id);
  }
};
</script>

<style scoped>
.ivu-form-item {
  margin-bottom: 0px;
  vertical-align: top;
  zoom: 1;
}
.plan-table {
  width: 100%;
}
.plan-table th {
  text-align: left;
  padding: 3px;
  border: 1px solid #eeeeee;
}
.plan-table td {
  text-align: left;
  height: 25px;
  line-height: 25px;
  padding: 3px;
  border: 1px solid #eeeeee;
}
</style>



// WEBPACK FOOTER //
// teacherAudit.vue?24a29f12